import { generateSessionId } from "@towni/common";

const towniSessionId = generateSessionId();
export { towniSessionId };
